import { Card } from '@radix-ui/themes'
import { CardHeader, CardTitle, CardContent } from './ui/card'
import { ArrowLeft, CheckCircle, CircleAlert, MailCheck} from 'lucide-react'
import { Button } from './ui/button'
import { useResendVerificationEmail } from '@/hooks/use-Auth'
import { toast } from '@/hooks/use-toast'

const EmailNotVerified = () => {
  const email = new URLSearchParams(window.location.search).get("email");

  const { mutate: resendVerificationEmail, isPending } = useResendVerificationEmail();

  const handleResendVerificationEmail = () => {
    if (!email) {
      toast({
        title: "Resend verification email",
        description: `Failed to re-send verification email, email is not provided`,
        variant: "destructive",
        icon: <CircleAlert size={30} className="animate-spin-once text-red-600"/>,
        duration: 4000
      })

      return
    }

    resendVerificationEmail(email, {
      onSuccess: (message) => (
        toast({
          title: "Resend verification email",
          description: `${message.message}`,
          icon: <CheckCircle size={30} className="animate-spin-once text-green-600" />,
          duration: 4000
        })
      ),
      onError: (error: any) => {
        const message = error?.response?.data?.message || "Something went wrong"

        toast({
          title: "Resend verification email",
          description: `${message}`,
          variant: "destructive",
          icon: <CircleAlert size={30} className="animate-spin-once text-red-600"/>,
          duration: 4000
        })
      }
    });
  }

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-700">
      <Card className="w-full max-w-xl mx-4 bg-white/90 backdrop-blur-sm shadow-xl">
        <CardHeader className="space-y-1">
          <a href='/' className='sm:absolute flex flex-row gap-1'>
            <ArrowLeft size={24} className="" /> 
            <p className='font-medium'>Back to login</p>
          </a>
          <MailCheck size={70} className="w-full text-green-500" />
          <CardTitle className="text-3xl text-gray-700 text-center font-medium">Verify your email address</CardTitle>
        </CardHeader>
        <CardContent>
          <p className='text-center text-gray-700'>Confirmation email has been sent to:</p>
          <p className='text-lg text-center my-3 font-bold'>{email}</p>
          <p className='text-center text-gray-700 mb-10'>
            Click on the link in the email to validate your email. If you dont see it, you may need to
            <span className='font-semibold'> check the spam folder</span>.
          </p>
          <p className='text-center font-medium'>Did not received the verification email?</p>
          <div className='flex justify-center'>
            <Button 
              className="my-4 bg-blue-600 hover:bg-blue-700"
              onClick={() => handleResendVerificationEmail()}
              disabled={isPending}
            >
              {isPending ? "Resending verification email ......" : "Resend verification email"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default EmailNotVerified